<template>
  <button
    type="button"
    class="h-13 bg-situational-lightgrey relative flex items-center rounded-xl border p-4 text-base outline-none transition duration-300"
    :class="
      isActive
        ? 'border-background-positive-primary'
        : 'border-situational-lightgrey'
    "
  >
    <span
      class="text-text-neutral-quaternary duration-150"
      :class="formattedDate && 'hidden'"
    >
      {{ placeholder }}
    </span>
    <p
      class="text-text-neutral-primary font-semibold leading-none"
    >
      {{ formattedDate }}
    </p>
    <ClearDateButton
      v-if="clearable && date"
      class="absolute right-4"
      @onDateClear="emit('onDateClear')"
    />
  </button>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { dateUtils } from 'shared';

  import ClearDateButton from './ClearDateButton.vue';

  const props = defineProps<{
    date?: string;
    clearable?: boolean;
    placeholder?: string;
    isActive?: boolean;
  }>();

  const formattedDate = computed(() =>
    props.date ? dateUtils.format(props.date, 'D MMMM, dd') : '',
  );

  const emit = defineEmits<{
    (e: 'onDateClear'): void;
  }>();
</script>
